export default "<div v-if=\"error\" class=\"alert alert-danger\">{{error}}</div>\r\n<TsmSpinner :isVisible=\"showSpinner\"></TsmSpinner>"